import { Component, type ErrorInfo, type ReactNode } from "react";

export default class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error: Error, info: ErrorInfo) { console.error("Display error", error, info); }
  render() {
    if (this.state.failed) return <main className="fatal-error">
      <span className="eyebrow">Algarve Projects</span><h1>The display needs a moment.</h1>
      <p>Check the connection, then tap below to return to the map.</p>
      <button className="button primary" onClick={() => window.location.assign("/display")}>Return to map</button>
    </main>;
    return this.props.children;
  }
}
